import React, { Component } from 'react';

export default class Discover extends Component {
    render() {
        return <section class="blog section bg-light">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 col-12">
                        <div class="title-content text-center text-md-start">
                            <h2 class="fw-bold">Descover Find Best NFT</h2>
                            <p class="text-muted">Start an Extraodinary Era of Digital Art and Music</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="text-md-end text-center">
                            <button class="btn btn-primary ">Discover All <i class="mdi mdi-chevron-right"></i></button>
                        </div>
                    </div>
                </div>


                <div class="row mt-5">
                    <div class="col-lg-3 col-md-6">
                        <div class="card border-0">
                            <div class="blog-image">
                                <img src="images/blog/img-1.png" alt="" class="img-fluid" />
                            </div>
                            <div class="card-body ">
                                <div class="d-flex">
                                    <h6 class="fw-bold mb-0">Community On Tour</h6>
                                    <p class="text-success ms-auto fw-bold mb-0">2.84 ETH</p>
                                </div>
                                <p class="text-muted">@imogee</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="card border-0">
                            <div class="blog-image">
                                <img src="images/blog/img-1.png" alt="" class="img-fluid" />
                            </div>
                            <div class="card-body ">
                                <div class="d-flex">
                                    <h6 class="fw-bold mb-0">Community On Tour</h6>
                                    <p class="text-success ms-auto fw-bold mb-0">2.84 ETH</p>
                                </div>
                                <p class="text-muted">@imogee</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="card border-0">
                            <div class="blog-image">
                                <img src="images/blog/img-1.png" alt="" class="img-fluid" />
                            </div>
                            <div class="card-body ">
                                <div class="d-flex">
                                    <h6 class="fw-bold mb-0">Community On Tour</h6>
                                    <p class="text-success ms-auto fw-bold mb-0">2.84 ETH</p>
                                </div>
                                <p class="text-muted">@imogee</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="card border-0">
                            <div class="blog-image">
                                <img src="images/blog/img-1.png" alt="" class="img-fluid" />
                            </div>
                            <div class="card-body ">
                                <div class="d-flex">
                                    <h6 class="fw-bold mb-0">Community On Tour</h6>
                                    <p class="text-success ms-auto fw-bold mb-0">2.84 ETH</p>
                                </div>
                                <p class="text-muted">@imogee</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="card border-0">
                            <div class="blog-image">
                                <img src="images/blog/img-1.png" alt="" class="img-fluid" />
                            </div>
                            <div class="card-body ">
                                <div class="d-flex">
                                    <h6 class="fw-bold mb-0">Community On Tour</h6>
                                    <p class="text-success ms-auto fw-bold mb-0">2.84 ETH</p>
                                </div>
                                <p class="text-muted">@imogee</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="card border-0">
                            <div class="blog-image">
                                <img src="images/blog/img-1.png" alt="" class="img-fluid" />
                            </div>
                            <div class="card-body ">
                                <div class="d-flex">
                                    <h6 class="fw-bold mb-0">Community On Tour</h6>
                                    <p class="text-success ms-auto fw-bold mb-0">2.84 ETH</p>
                                </div>
                                <p class="text-muted">@imogee</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="card border-0">
                            <div class="blog-image">
                                <img src="images/blog/img-1.png" alt="" class="img-fluid" />
                            </div>
                            <div class="card-body ">
                                <div class="d-flex">
                                    <h6 class="fw-bold mb-0">Community On Tour</h6>
                                    <p class="text-success ms-auto fw-bold mb-0">2.84 ETH</p>
                                </div>
                                <p class="text-muted">@imogee</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6">
                        <div class="card border-0">
                            <div class="blog-image">
                                <img src="images/blog/img-1.png" alt="" class="img-fluid" />
                            </div>
                            <div class="card-body ">
                                <div class="d-flex">
                                    <h6 class="fw-bold mb-0">Community On Tour</h6>
                                    <p class="text-success ms-auto fw-bold mb-0">2.84 ETH</p>
                                </div>
                                <p class="text-muted">@imogee</p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>;
    }
}
